import { Converter } from '../types/converter';

export const flowMassConverter: Converter = {
  id: 'flowMass',
  name: 'Mass Flow Converter',
  icon: 'ArrowRight',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit
    { name: 'Kilogram/second', symbol: 'kg/s', factor: 1 },
    
    // Gram-based units
    { name: 'Gram/second', symbol: 'g/s', factor: 0.001 },
    { name: 'Gram/minute', symbol: 'g/min', factor: 1.666667e-5 },
    { name: 'Gram/hour', symbol: 'g/h', factor: 2.777778e-7 },
    { name: 'Gram/day', symbol: 'g/d', factor: 1.157407e-8 },
    
    // Milligram units
    { name: 'Milligram/second', symbol: 'mg/s', factor: 1e-6 },
    { name: 'Milligram/minute', symbol: 'mg/min', factor: 1.666667e-8 },
    { name: 'Milligram/hour', symbol: 'mg/h', factor: 2.777778e-10 },
    { name: 'Milligram/day', symbol: 'mg/d', factor: 1.157407e-11 },
    
    // Kilogram-based units
    { name: 'Kilogram/minute', symbol: 'kg/min', factor: 0.016666667 },
    { name: 'Kilogram/hour', symbol: 'kg/h', factor: 0.000277778 },
    { name: 'Kilogram/day', symbol: 'kg/d', factor: 1.157407e-5 },
    
    // SI prefixed units
    { name: 'Exagram/second', symbol: 'Eg/s', factor: 1e18 },
    { name: 'Petagram/second', symbol: 'Pg/s', factor: 1e15 },
    { name: 'Teragram/second', symbol: 'Tg/s', factor: 1e12 },
    { name: 'Gigagram/second', symbol: 'Gg/s', factor: 1e9 },
    { name: 'Megagram/second', symbol: 'Mg/s', factor: 1e6 },
    { name: 'Hectogram/second', symbol: 'hg/s', factor: 0.1 },
    { name: 'Dekagram/second', symbol: 'dag/s', factor: 0.01 },
    { name: 'Decigram/second', symbol: 'dg/s', factor: 0.0001 },
    { name: 'Centigram/second', symbol: 'cg/s', factor: 0.00001 },
    { name: 'Microgram/second', symbol: 'µg/s', factor: 1e-9 },
    
    // Metric ton units
    { name: 'Ton (metric)/second', symbol: 't/s', factor: 1000 },
    { name: 'Ton (metric)/minute', symbol: 't/min', factor: 16.666667 },
    { name: 'Ton (metric)/hour', symbol: 't/h', factor: 0.277778 },
    { name: 'Ton (metric)/day', symbol: 't/d', factor: 0.011574 },
    
    // Imperial/US units
    { name: 'Ton (short)/hour', symbol: 'ton (US)/h', factor: 0.251996 },
    { name: 'Pound/second', symbol: 'lb/s', factor: 0.453592 },
    { name: 'Pound/minute', symbol: 'lb/min', factor: 0.007560 },
    { name: 'Pound/hour', symbol: 'lb/h', factor: 0.000126 },
    { name: 'Pound/day', symbol: 'lb/d', factor: 5.25e-6 }
  ]
};
